import React, { useContext, useEffect } from "react";
// styled components
import { Row, Image, Menu, Col } from "antd";
// images
import Logo from "../../../assets/logo_alcaldia_medellin.svg";
// styles
import "./layout.style.scss";
// router
import { useNavigate } from "react-router";
import SubMenu from "antd/lib/menu/SubMenu";

import { TemplateContext } from "../../../utils/template_context";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "../../../hooks/useEncrypt";
// import { cambiarPestaña, edicionConvocatoria, idConvocatorias } from "../../../../redux/actions/convocatoriaAction";
import getStorageUser from "../../../middlewares/GetStorageUser";

export const CMenu = () => {
  const context = useContext(TemplateContext);
  const navigate = useNavigate();
  const { encrypt } = useEncrypt();

  const consultarconvocatioria = async (redirect: string) => {
    try {
      localStorage.removeItem("editar_convocatoria");
      let { data } = await apiConvocatorias.consultarNumeroConvocatoria();
      localStorage.setItem("id_convocatoria", encrypt(data.data.toString()));
      localStorage.setItem("cambiarPestaña", encrypt("1"));
      navigate(redirect);
    } catch (error) {
      return console.error(error);
    }
  };

  const crearArtistas = async () => {
    localStorage.removeItem("editar_convocatoria");
    localStorage.removeItem("id_convocatoria");
    consultarconvocatioria("/administrador/infoconvocatoria");
  };

  const crearJurados = async () => {
    localStorage.removeItem("editar_convocatoria");
    localStorage.removeItem("id_convocatoria");
    consultarconvocatioria("/administrador/infoJurados");
  };

  const crearBeps = async () => {
    localStorage.removeItem("editar_convocatoria");
    localStorage.removeItem("id_convocatoria");
    consultarconvocatioria("/administrador/infoBeps");
  };

  useEffect(() => {
    const user = getStorageUser()

    if ( !user?.admin || user?.role_id > 2) {
      return navigate('/login')
    }
  }, [])

  return (
    <Row
      className="width-100"
      style={{
        flex: "1 1 auto",
        flexFlow: "column",
        overflow: "auto",
      }}
    >

      <Menu
        mode={context.device === "sm" ? "inline" : "vertical"}
        defaultSelectedKeys={["menu"]}
      >
        <Menu.Item

          key="menu"
          className="submenu-item-layout-view font-size-12px"
          onClick={() => navigate("/administrador")}
        >
          Página Principal

        </Menu.Item>
        <SubMenu
          key="sub1"
          title="Administración"
          style={{ width: "100%" }}
          className="width-100 submenu-item-layout-view font-size-12px"
        >

          <Menu.ItemGroup
          >
            <Menu.Item
              key="1"
              className="submenu-item-layout-view font-size-12px"
              onClick={() => navigate("/administrador/gestionRoles")}
            >
              Gestionar roles
            </Menu.Item>
            <SubMenu
              key="SubMenuMaetras"
              title="Gestionar Maestras"
              className="width-100 submenu-item-layout-view font-size-12px"
            >
              <Menu.Item
                key="2"
                className="submenu-item-layout-view font-size-12px"
                onClick={() => navigate("/administrador/gestionMaestras")}
              >
                Convocatorias
              </Menu.Item>
              <Menu.Item
                key="3"
                className="submenu-item-layout-view font-size-12px"
                onClick={() =>
                  navigate("/administrador/gestionMaestrasJurados")
                }
              >
                Jurados
              </Menu.Item>
            </SubMenu>
            {/* <Menu.Item key="2">Gestionar Maestras</Menu.Item> */}
          </Menu.ItemGroup>
        </SubMenu>
        <Row style={{ marginBottom: "20px" }}>
          <Col
            className="font-color-101c31 font-size-14px font-family-Montserrat-SemiBold"
            style={{ paddingTop: "38px", paddingLeft: "16px" }}
          >
            Fomento a la cultura
          </Col>
        </Row>
        <SubMenu
          key="sub2"
          title="Convocatorias"
          style={{ width: "100%" }}
          className="menu-item-layout-view font-size-12px"
        >
          <Menu.ItemGroup /* className="font-size-12px padding-left-11 menu-item-layout-view" */
          >
            <Menu.Item
              key="4"
              onClick={() => navigate("/administrador/tablaconvocatorias")}
              className="submenu-item-layout-view font-size-12px"
            >
              Tablero de Convocatorias
            </Menu.Item>
            <SubMenu
              key="SubMenuConvocatorias"
              title="Crear Convocatoria"
              className="submenu-item-layout-view font-size-12px"
            >
              <Menu.Item
                key="5"
                onClick={crearArtistas}
                className="submenu-item-layout-view font-size-12px"
              >
                Crear Convocatoria Artistas
              </Menu.Item>
              <Menu.Item
                key="6"
                onClick={crearJurados}
                className="submenu-item-layout-view font-size-12px"
              >
                Crear Convocatoria Jurados
              </Menu.Item>
              <Menu.Item
                key="7"
                onClick={crearBeps}
                className="submenu-item-layout-view font-size-12px"
              >
                Crear Convocatoria Beps
              </Menu.Item>
            </SubMenu>
          </Menu.ItemGroup>
        </SubMenu>
        <SubMenu
          key="sub3"
          title="Postulaciones"
          style={{ width: "100%" }}
          className="menu-item-layout-view font-size-12px"
        >
          <Menu.ItemGroup /* className="font-size-12px padding-left-11 menu-item-layout-view" */
          >
            <Menu.Item
              key="8"
              onClick={() => navigate("/administrador/gestionarPostulaciones")}
              className="submenu-item-layout-view font-size-12px"
            >
              Artistas
            </Menu.Item>
            <Menu.Item
              key="9"
              onClick={() => navigate("/administrador/bancoJurados")}
              className="submenu-item-layout-view font-size-12px"
            >
              Banco de Jurados
            </Menu.Item>
            <Menu.Item
              key="10"
              onClick={() => navigate("/administrador/gestionEvaluador")}
              className="submenu-item-layout-view font-size-12px"
            >
              Gestión Evaluador
            </Menu.Item>
            <Menu.Item
              key="11"
              onClick={() =>
                navigate("/administrador/gestionarPostulacionesBeps")
              }
              className="submenu-item-layout-view font-size-12px"
            >
              Beps
            </Menu.Item>
          </Menu.ItemGroup>
        </SubMenu>
        <SubMenu
          key="sub4"
          title="Gestión Jurados"
          style={{ width: "100%" }}
          className="menu-item-layout-view font-size-12px"
        >
          <Menu.ItemGroup /* className="font-size-12px padding-left-11 menu-item-layout-view" */
          >
            {/* <Menu.Item key="11" className="submenu-item-layout-view">Artistas</Menu.Item> */}
            <Menu.Item
              key="12"
              className="submenu-item-layout-view font-size-12px"
              onClick={() => navigate("/administrador/asignarJurados")}
            >
              Asignar Proyecto
            </Menu.Item>
            <Menu.Item
              key="13"
              className="submenu-item-layout-view font-size-12px"
              onClick={() => navigate("/administrador/seguimientoProyectos")}
            >
              Resultado Evaluación
            </Menu.Item>
            <Menu.Item
              key="14"
              className="submenu-item-layout-view font-size-12px"
              onClick={() => navigate("/administrador/invitacionJurados")}
            >
              Inscripción Extemporánea
            </Menu.Item>
            <Menu.Item
              key="15"
              className="submenu-item-layout-view font-size-12px"
              onClick={() => navigate("/administrador/listadoPostulaciones")}
            >
              Registro de Pagos
            </Menu.Item>
          </Menu.ItemGroup>
        </SubMenu>
        <SubMenu
          key="sub5"
          title="Notificaciones"
          style={{ width: "100%" }}
          className="menu-item-layout-view font-size-12px"
        >
          <Menu.ItemGroup /* className="font-size-12px padding-left-11 menu-item-layout-view" */
          >
            <Menu.Item
              key="16"
              onClick={() => navigate("/administrador/centroNotificaciones")}
              className="submenu-item-layout-view font-size-12px"
            >
              Centro de Notificaciones
            </Menu.Item>
            <Menu.Item
              key="17"
              onClick={() => navigate("/administrador/enviarNotificaciones")}
              className="submenu-item-layout-view font-size-12px"
            >
              Enviar Notificaciones
            </Menu.Item>
          </Menu.ItemGroup>
        </SubMenu>
      </Menu>
    </Row>
  );
};

export const LayoutMenu = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Row
        className="width-100 background-color-101c31"
        style={{ display: "flex", justifyContent: "center", padding: "20px" }}
      >
        {/* <Row className="width-100"> */}
        <Image
          className="image-size-sider-admin"
          src={Logo}
          preview={false}
          style={{ margin: "0 auto" }}
        />

        {/* </Row> */}
      </Row>
      <CMenu />
    </div>
  );
};
